export const exercisePreviews = [
  {
    src: "https://tumejorversion.life/fitpack/es/assets/img/4524232-768x1024.webp",
    alt: "Vista previa de ejercicio 1",
  },
  {
    src: "https://tumejorversion.life/fitpack/es/assets/img/245252-768x1024.webp",
    alt: "Vista previa de ejercicio 2",
  },
  {
    src: "https://tumejorversion.life/fitpack/es/assets/img/2345235-768x1024.webp",
    alt: "Vista previa de ejercicio 3",
  },
  {
    src: "https://tumejorversion.life/fitpack/es/assets/img/2525-768x1024.webp",
    alt: "Vista previa de ejercicio 4",
  },
  {
    src: "https://tumejorversion.life/fitpack/es/assets/img/235235-768x1024.webp",
    alt: "Vista previa de ejercicio 5",
  },
  {
    src: "https://tumejorversion.life/fitpack/es/assets/img/23523523-768x1024.webp",
    alt: "Vista previa de ejercicio 6",
  },
] as const;

export const receiveBenefits = [
  "Acceso a +1.000 GIFs de ejercicios en alta calidad.",
  "Un paquete completo para transformar y corregir la ejecución de tus alumnos.",
  "GIFs en alta resolución, ligeros y perfectamente organizados para un envío rápido.",
  "Organización por categorías (Musculación, Funcional, Movilidad, etc.) y en orden alfabético (A-Z).",
  "Acceso inmediato a la biblioteca completa para descarga y uso.",
  "Permiso de uso comercial para usar en tu atención sin preocupaciones.",
  "Acceso vitalicio: paga una vez y úsalo para siempre, incluyendo futuras actualizaciones.",
  "Recibes todo al instante, directamente en tu correo electrónico.",
] as const;
